import React from 'react';
import { Box, Typography } from '@mui/material';
import { BookingPreparationState } from 'common/modules/bookings';
import { getBookingPreparationStateLabel } from '../utils/labels';
import { useTranslation } from 'services/localization';

export interface Props {
	preparationState: BookingPreparationState;
}
const BookingPreparationStateBadge = (props: Props) => {
	const { t } = useTranslation();
	const { preparationState } = props;

	return preparationState === 'PREPARED' ? (
		<Box
			display="flex"
			justifyContent="center"
			alignItems="center"
			p={1}
			sx={{ bgcolor: (theme) => theme.palette.background.secondary, borderRadius: 16 }}
		>
			<Typography fontSize="1.2rem">
				{getBookingPreparationStateLabel(preparationState, t)}
			</Typography>
		</Box>
	) : null;
};

export default BookingPreparationStateBadge;
